// SORT_BY_FIELD
export const setFieldFilter = (fields) => ({
    type: 'SORT_BY_FIELD',
    fields
});


// WEBPACK FOOTER //
// ./src/actions/filters.js